import React, { useState } from 'react';
import { ASSETS } from '../assetManifest';
import { PLAYER } from '../playerData';

function Home({ app }) {
  const [playerName, setPlayerName] = useState(PLAYER.name);

  const handleStartGame = (isSinglePlayer) => {
    app.setPlayerName(playerName);
    app.goToGame(isSinglePlayer);
  };

  return (
    <div className="h-full w-full mx-auto relative overflow-hidden text-white">
      <img 
        className="absolute inset-0 w-full h-full object-cover" 
        src={ASSETS.backgrounds.homeBg.path} 
        alt="Home Background" 
      />
      
      <div className="p-4 flex flex-col h-full relative z-10">
        {/* Title banner image - adjusted size */}
        <div className="flex justify-center mt-14 mb-2">
          <img 
            src={ASSETS.logos.title.path} 
            alt="Game Title" 
            className="w-auto object-contain"
            style={{ width: '330px', height: '220px' }}
          />
        </div>
        
        <div className="flex-grow flex flex-col items-center justify-end gap-4 pb-16">
          <div className="w-[319px] h-[66px] bg-white rounded-[9px] border-2 border-black relative">
            <input
              type="text"
              value={playerName}
              onChange={(e) => setPlayerName(e.target.value)}
              placeholder="Player Name"
              className="w-[282px] h-[35px] absolute left-[21px] top-[15px] text-black text-2xl font-extrabold font-['Asap'] leading-[60px] bg-transparent border-none outline-none"
            />
          </div>
          
          <div className="w-[184px] h-[66.29px] bg-[#fff200] rounded-[9px] shadow-[inset_0px_-6px_2px_0px_rgba(123,117,0,1.00)] border-2 border-[#030000] relative">
            <button
              onClick={() => handleStartGame(true)}
              className="w-[170.46px] h-[53.70px] absolute left-[5.58px] top-[5.87px] text-center text-[#030303] text-[32px] font-extrabold font-['Asap'] capitalize leading-[53.70px] tracking-wide bg-transparent border-none outline-none cursor-pointer"
            >
              Start
            </button>
          </div>
          
          <button
            onClick={() => handleStartGame(false)}
            className="w-[231px] h-[61px] text-center text-white text-2xl font-extrabold font-['Asap'] leading-[60px] [text-shadow:_0px_2px_1px_rgb(0_0_0_/_1.00)] bg-transparent border-none outline-none cursor-pointer"
          >
            Play with Friends
          </button>
        </div>
      </div>
    </div>
  );
}

export default Home;
